<script setup lang="ts">
import pageErrorStateImage from '../../assets/page-error-state.svg';

defineProps<{
  error?: Error;
}>();
</script>

<template>
<div class="page-error-state">
  <el-image class="image" :src="pageErrorStateImage"/>
  <div class="title">{{ $t("cms_setting.page_error_state.title") }}</div>
  <div class="description">{{ $t("cms_setting.page_error_state.description") }}</div>
  <div class="message">({{ error?.message || 'Unknown error' }})</div>
</div>
</template>
<style lang="scss" scoped>
.page-error-state {
  @apply container mx-auto h-screen flex flex-col justify-center items-center;
  @apply px-5;

  .image {
    @apply mb-6 p-3;
  }

  .title {
    @apply mb-4 text-4xl font-semibold text-black;
    @apply text-center;
  }

  .description {
    @apply mb-2 text-gray-800;
    @apply text-center;

    font-size: 22px;
  }

  .message {
    @apply text-sm text-gray-800;
    @apply text-center;
  }
}
</style>
